var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button, Tooltip, TooltipPortal } from "@animech/ui";
import * as Styled from "./icon-button.style";
export var IconButton = function (_a) {
    var iconSize = _a.iconSize, _b = _a.variant, variant = _b === void 0 ? "circle" : _b, focused = _a.focused, tooltip = _a.tooltip, title = _a.title, props = __rest(_a, ["iconSize", "variant", "focused", "tooltip", "title"]);
    var button = (_jsx(Styled.IconButton, { iconSize: iconSize || 18, variant: variant, focused: focused, title: title, children: _jsx(Button, __assign({}, props)) }));
    return tooltip ? (_jsx(TooltipPortal, { anchorElement: button, toggleEvent: "hover", placement: "top", children: _jsx(Tooltip, { css: { zIndex: 1 }, color: "neutral", children: tooltip }) })) : (button);
};
